import React, { ReactNode } from 'react';
import { faChevronUp, faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { SalvIconButton, Size } from '@salvapp/ui-components';
import './ExpanderButton.scss';
import { clsx } from 'clsx';

interface Props {
  isExpanded: boolean;
  onClick: () => void;
  showLabel?: ReactNode;
  hideLabel?: ReactNode;
  ariaLabel?: string;
  disabled?: boolean;
  className?: string;
}

const ExpanderButton = ({
  isExpanded,
  showLabel = 'More info',
  hideLabel = 'Show less',
  ariaLabel = 'More',
  onClick,
  className,
}: Props) => {
  return (
    <div onClick={onClick} className={clsx('salv-expander-button', className)}>
      <span>{isExpanded ? hideLabel : showLabel}</span>
      <SalvIconButton
        onClick={onClick}
        icon={isExpanded ? faChevronUp : faChevronDown}
        size={Size.SMALL}
        ariaLabel={ariaLabel}
        variant={'primary'}
      />
    </div>
  );
};

export default ExpanderButton;
